import { render, staticRenderFns } from "./FormModule.vue?vue&type=template&id=2e36d93c&"
import script from "./FormModule.vue?vue&type=script&lang=js&"
export * from "./FormModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports